import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs: ClassValue[]) { return twMerge(clsx(inputs)); }
export function money(value: number | string | null | undefined, digits = 2) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: digits, maximumFractionDigits: digits });
}
export const pct = (n: number, digits = 1) => `${n.toFixed(digits)}%`;
export const shortAddress = (a?: string | null) => a ? `${a.slice(0, 6)}…${a.slice(-4)}` : 'Not connected';
export function units(text: string, decimals: number) {
  if (!/^\d+(\.\d*)?$/.test(text)) throw new Error('Enter an ordinary non-negative decimal amount');
  const [a, b = ''] = text.split('.');
  if (b.length > decimals) throw new Error('Too many decimal places');
  return String(BigInt(a) * 10n ** BigInt(decimals) + BigInt((b + '0'.repeat(decimals)).slice(0, decimals) || '0'));
}
export function formatUnits(value: string | bigint | null | undefined, decimals: number, places = 6) {
  const n = BigInt(value ?? 0); const scale = 10n ** BigInt(decimals); const a = n / scale;
  const b = String(n % scale).padStart(decimals, '0').slice(0, places).replace(/0+$/, '');
  return String(a) + (b ? `.${b}` : '');
}
